import request from '#/utils/request';
import { withFmsActor } from '#/api/fmsMgmt/fmsActorConfig';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST `/fms/vouchers/{id}/submission`。
 * body 可為 `{}`；可選 `{ updatedAt }`。
 */
export async function submitVoucher(id, payload = {}) {
  const { data: raw } = await request.post(
    `/fms/vouchers/${id}/submission`,
    keysToSnake(payload),
    withFmsActor(),
  );
  return parseVer4DetailResponse(raw);
}
